import { Checkbox } from '@lib/components'
import type React from 'react'

import css from './List.module.scss'

type Props = {
  url: string
  isSelected: boolean
  onClick: (url: string) => void
}

const Item: React.FC<Props> = ({ url, isSelected, onClick }) => {
  return (
    <div className={css.item}>
      <div className={css.content}>
        <Checkbox
          name="item"
          size="large"
          checked={isSelected}
          onClick={() => onClick(url)}
        />
        <div className={css.label} onClick={() => onClick(url)}>
          <span className={css.name}>{url}</span>
        </div>
      </div>
    </div>
  )
}

export default Item
